import { render } from "./Events.vue?vue&type=template&id=2208ad30"
import script from "./Events.vue?vue&type=script&lang=ts"
export * from "./Events.vue?vue&type=script&lang=ts"
script.render = render

export default script